import { CometChat } from '@cometchat-pro/chat';

import { ICleanStoreAction } from 'store/reducers/types';

export type TMessage = CometChat.TextMessage | CometChat.MediaMessage | CometChat.CustomMessage | CometChat.BaseMessage

export interface IMessagesReducer {
  isConnected: boolean,
  isLoggedInChat: boolean,
  unreadList: { [key: string]: number },
  chats: {
    isCanUpdate: boolean,
    isNeedUpdate: boolean,
    list: CometChat.Conversation[] | [],
  },
  activeChat: {
    id: string,
    isTyping: boolean,
    isCanUpdate: boolean,
    messages: TMessage[],
  }
}

export enum MessagesActionsEnum {
  SetChatStatus = 'SET_CHAT_STATUS',
  GetChatsList = 'GET_CHATS_LIST',
  GetActiveMessages = 'GET_ACTIVE_MESSAGES_ACTION',
  SetActiveChatId = 'SET_ACTIVE_CHAT_ID',
  SendMessage = 'SEND_MESSAGE',
  GetMessage = 'GET_MESSAGE',
  SetIsOnlineUser = 'SET_IS_ONLINE_USER',
  SetIsTypingUser = 'SET_IS_TYPING_USER',
  SetMessageRead = 'SET_MESSAGE_READ',
  GetUnreadCountMessages = 'SET_UNREAD_COUNT_MESSAGES',
  AddChat = 'ADD_CHAT',
  ResetMessagesStore = 'RESET_MESSAGES_STORE',
}

export interface ISetChatStatusAction {
  type: MessagesActionsEnum.SetChatStatus;
  payload: { isConnected: boolean } | { isLoggedInChat: boolean };
}

export interface IGetChatsListAction {
  type: MessagesActionsEnum.GetChatsList;
  payload: {
    isUpdate?: boolean,
    isCanUpdate: boolean,
    list: CometChat.Conversation[] | []
  };
}

export interface IGetActiveListAction {
  type: MessagesActionsEnum.GetActiveMessages;
  payload: {
    isUpdate?: boolean,
    isCanUpdate: boolean,
    messages: CometChat.BaseMessage[] | []
  };
}

export interface ISetActiveChatIdAction {
  type: MessagesActionsEnum.SetActiveChatId;
  payload: { id: string };
}

export interface ISendMessageAction {
  type: MessagesActionsEnum.SendMessage;
  payload: TMessage;
}

export interface IGetMessageAction {
  type: MessagesActionsEnum.GetMessage;
  payload: { message: CometChat.TextMessage, newChat?: CometChat.Conversation, userId: string };
}

export interface ISetIsOnlineUserAction {
  type: MessagesActionsEnum.SetIsOnlineUser;
  payload: { list: CometChat.Conversation[] };
}

export interface ISetIsTypingUserAction {
  type: MessagesActionsEnum.SetIsTypingUser;
  payload: { isTyping: boolean };
}

export interface ISetMessageReadAction {
  type: MessagesActionsEnum.SetMessageRead;
  payload: CometChat.MessageReceipt;
}

export interface IGetUnreadCountMessagesAction {
  type: MessagesActionsEnum.GetUnreadCountMessages;
  payload: { unreadList: { [key: string]: number } };
}

export interface IAddChatAction {
  type: MessagesActionsEnum.AddChat;
  payload: { id: string, list: CometChat.Conversation[] };
}

export interface IResetMessagesStoreAction {
  type: MessagesActionsEnum.ResetMessagesStore;
}

export type MessagesActions =
  ISetChatStatusAction
  | IGetChatsListAction
  | IGetActiveListAction
  | ISetActiveChatIdAction
  | ISendMessageAction
  | IGetMessageAction
  | ISetIsOnlineUserAction
  | ISetIsTypingUserAction
  | ISetMessageReadAction
  | IGetUnreadCountMessagesAction
  | IAddChatAction
  | IResetMessagesStoreAction
  | ICleanStoreAction

